import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';

import { ApiService } from '@services/api.service';
import { Task, stopEvent } from '@models';
import { BaseMin } from '@base/base-min';

@Component({
    selector: 'vz-task-favorite, [vz-task-favorite]',
    template: `
        @if (task(); as t) {
            <div class="layout center-center" style="width: 24px; height: 24px;">
                @if (_working()) {
                    <div class="loader micro"></div>
                }
                @else {
                    <i class="fs-3xl top-2"
                        [class]="t.flags.favorite ? 'vzi-star txt-warn' : 'vzi-star-o txt-l'"
                        (click)="toggle($event)">
                    </i>
                }
            </div>
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaskFavoriteComponent extends BaseMin {
    readonly task = input<Task>();

    private readonly _api = inject(ApiService);


    toggle(e: MouseEvent): void {
        stopEvent(e);
        const task = this.task();
        if (this._working() || !task?.id) {
            return;
        }
        this._Working(this._api.setTaskConditions(task.id, { favorite: !task.flags.favorite })).subscribe();
    }

}
